import { useFieldError } from "@/shared/contexts/field-error-context";

interface FieldErrorProps {
  formId: string;
  /** Dot/bracket path matching the backend FieldError.field, e.g. "customer.phone". */
  field: string;
  className?: string;
}

/**
 * Drop-in inline error message bound to a single form field. Reads from
 * FieldErrorContext keyed by formId; renders nothing when no error is present.
 *
 * <FieldError formId="createOrder" field="customer.phone" />
 */
export const FieldError = ({ formId, field, className }: FieldErrorProps) => {
  const errors = useFieldError(formId, field);
  if (errors.length === 0) return null;

  return (
    <p
      role="alert"
      className={className ?? "text-red-500 text-xs mt-1"}
    >
      {errors.map((e) => e.userMessage).join(" ")}
    </p>
  );
};
